<template>
    <div class="series-container">
        <div class="title">
            <div class="module-title" v-html="service.caption"></div>
            <div class="module-sub-title" v-if="service.desc">
                <span class="text" v-html="service.desc">
                </span>
            </div>
        </div>
        <List class="steps" :items="service.items"></List>
    </div>
</template>

<script>
    import List from './List'

    export default {
        name: 'ServiceList',
        props: {
            service: Object,
        },
        components: {
            List
        },
    }
</script>

<style lang="less" scoped>
    @import "../../../assets/style/var";

    .en {
        .series-container /deep/ .title {

            .module-title {
                font-size: 26px !important;
            }

            .module-sub-title {
                margin-top: 15px !important;
            }
        }
    }

    .btn {
        margin-top: 90px;
    }

    .series-container /deep/ .title {

        .module-title {
            font-size: 28px !important;
            line-height: 54px !important;
            font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
        }

        .module-sub-title {
            margin-top: 15px !important;
        }
    }

    .steps {
        margin-bottom: 176px;
        /deep/ .list .list-item {
            flex-wrap: nowrap;

            .col {
                margin-top: 0 !important;
                overflow-y: hidden;
            }
        }
    }

</style>
